import { settings } from '../../../engine/settings-sidecar'
import { soundsGeneric } from '../../../engine/soundsGeneric-sidecar'
import { rando } from '../../../lib/rando-sidecar'

let _musicPath = ''

export function getMusicPath() {
  return _musicPath
}
export function setMusicPath(path: string) {
  let hrefDir = window.location.href
  let idx = hrefDir.lastIndexOf('/')
  if (idx != -1) {
    hrefDir = hrefDir.substring(0, idx)
  }
  _musicPath = hrefDir + path
  console.log('music path', _musicPath)
}

export function toggleMusic() {
  settings.update({ muteMusic: !settings.get().muteMusic })
}

export function setVolume(vol: number) {
  soundsGeneric.setMusicVolume(vol)
}

const _masterMusicVolume = 0.5
const _songs = [
  'MedievalTavern_Song(NoLoop)',
  'TavernSong_Loop_CompleteTrack',
  'TavernStory_Loop_CompleteTrack',
]
export function playMusic1() {
  let song = rando.sample(_songs)
  soundsGeneric.playMusic(
    _musicPath + song,
    false,
    () => {
      playMusic1()
    },
    _masterMusicVolume,
  )
}
export function playMusicMenu() {
  soundsGeneric.playMusic(
    _musicPath + 'TheTavernIsCalm_Loop_CompleteTrack',
    true,
    () => {},
    _masterMusicVolume,
  )
}
